import React from "react";
import { Button, Icon, Input, Popconfirm, Table } from "antd/lib/index";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteUser, getFirebaseData } from "../../../redux/actions/network";
import { resetPassword } from "../../../redux/actions/users";
import { selectCurrentUser } from "../../../redux/selectors/auth";
import { selectAllEntities } from "../../../redux/selectors/global";
import { selectGroupByKey } from "../../../redux/selectors/groups";

const generator = require("generate-password");

class AlumnosList extends React.Component {
  state = {
    filteredInfo: null,
    sortedInfo: null,
    searchText: ""
  };

  handleChange = (_, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter
    });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] &&
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => {
      return (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={(text && text.toString()) || ""}
        />
      );
    }
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const { resetPassword, deleteUser, users, userGroup } = this.props;
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};

    const columnns = [
      {
        title: "Nombres y Apellidos",
        dataIndex: "nombre",
        key: "nombre",
        width: "20%",
        ...this.getColumnSearchProps("nombre")
      },
      {
        title: "Nivel",
        dataIndex: "nivel",
        filteredValue: filteredInfo.nivel || null,
        onFilter: (value, record) => record.nivel == value,
        filters: [
          { text: "Quintos Niveles", value: "5" },
          { text: "Sexto Nivel", value: "6" },
          { text: "Septimo Nivel", value: "7" }
        ],
        width: "20%"
      },
      {
        title: "Identificador Nivel",
        dataIndex: "identificadorNivel",
        filteredValue: filteredInfo.identificadorNivel || null,
        onFilter: (value, record) => record.identificadorNivel == value,
        filters: [
          { text: "A", value: "A" },
          { text: "B", value: "B" },
          { text: "C", value: "C" }
        ],
        width: "20%"
      },
      {
        title: "Rut",
        dataIndex: "rut"
      },
      {
        title: "Colegio",
        dataIndex: "colegio",
        ...this.getColumnSearchProps("colegio")
      },
      {
        title: "Grupo",
        dataIndex: "groupKey",
        render: (current, row, index) => {
          const ug = userGroup(row.key);

          return (
            <div>{(ug && ug.nombreGrupo) || "No se ha creado grupo aun"}</div>
          );
        }
      },

      {
        title: "Password",
        dataIndex: "password"
      },
      {
        title: "Edit Password",
        dataIndex: "key",
        key: "editPassowrd",
        render: x => (
          <Popconfirm
            title="Are you you sure you wanna reset the password"
            onConfirm={() => {
              return resetPassword(
                x,
                generator.generate({
                  length: 8
                })
              );
            }}
            onCancel={e => console.log(e)}
            okText="Do it"
            cancelText="Cancelar"
          >
            <Button>Edit Password</Button>
          </Popconfirm>
        )
      },
      {
        title: "Delete user",
        dataIndex: "key",
        key: "deleteUser",
        render: x => (
          <Popconfirm
            title="Are you sure you wanna delete this user?"
            onConfirm={() => {
              return deleteUser(x);
            }}
            onCancel={e => console.log(e)}
            okText="Do it"
            cancelText="Cancelar"
          >
            <Button variant="danger">Delete User</Button>
          </Popconfirm>
        )
      }
    ];

    return (
      <React.Fragment>
        <Table
          columns={columnns}
          rowKey={student => student.key}
          dataSource={users}
          loading={users && users.length === 0}
          onChange={this.handleChange}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getFirebaseData, resetPassword, deleteUser }, dispatch);

const mapStateToProps = state => {
  const users = selectAllEntities(state, "users");
  const currentUser = selectCurrentUser(state);
  const userGroup = groupKey => selectGroupByKey(state, groupKey);

  return {
    users,
    currentUser,
    userGroup
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlumnosList);
